import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { PrivatePolicyComponent } from '@privacy-policy/privacy-policy/privacy-policy.component';
import { PrivacyPolicyRoutingModule } from '@privacy-policy/privacy-policy-routing.module';
import { ModalModule } from '@ux/components/modal/modal.module';
import { PrivatePolicyBRComponent } from '@privacy-policy/privacy-policy/br/privacy-policy-br.component';
import { PrivatePolicyMXComponent } from '@privacy-policy/privacy-policy/mx/privacy-policy-mx.component';
import { PrivacyPolicyArComponent } from '@privacy-policy/privacy-policy/ar/privacy-policy-ar.component';
import { PrivacyPolicyPeComponent } from '@privacy-policy/privacy-policy/pe/privacy-policy-pe.component';
import { PrivatePolicyClComponent } from '@privacy-policy/privacy-policy/cl/privacy-policy-cl.component';

@NgModule({
  declarations: [
    PrivatePolicyComponent,
    PrivatePolicyBRComponent,
    PrivatePolicyMXComponent,
    PrivacyPolicyArComponent,
    PrivacyPolicyPeComponent,
    PrivatePolicyClComponent,
  ],
  imports: [
    CommonModule,
    PrivacyPolicyRoutingModule,
    TranslocoModule,
    ModalModule

  ]
})
export class PrivacyPolicyModule { }
